import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-lsoacknowledgement-notice',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './lsoacknowledgement-notice.component.html',
  styleUrls: ['./lsoacknowledgement-notice.component.scss']
})
export class LSOAcknowledgementNoticeComponent implements OnInit {
  
  @Input() data: any;
  @Output() onClose = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {}

  sendConfirmation(note: string): void {
    this.onClose.emit(note);
  }

}
